import _regenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { defaultMissionInfReadingData, deleteMissionInfoReading, getMissionInfoReadings, updateMissionInfoReadingOrder } from '@/api/missionInfoReading';
import WriteReading from './WriteReading.vue';
import Sortable from 'sortablejs';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, default_1, [].concat(args));
    _defineProperty(_this, "missionInfo", void 0);
    _defineProperty(_this, "title", void 0);
    _defineProperty(_this, "visible", void 0);
    _defineProperty(_this, "action", void 0);
    _defineProperty(_this, "list", []);
    _defineProperty(_this, "listLoading", false);
    _defineProperty(_this, "edit", {
      showDialog: false,
      title: '',
      action: '',
      reading: {}
    });
    _defineProperty(_this, "sortable", null);
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "onShowDialogChange",
    value: function onShowDialogChange(showDialog, oldValue) {
      if (showDialog === false) {
        this.getList();
      }
    }
  }, {
    key: "getList",
    value: function () {
      var _getList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this2 = this;
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.missionInfo.id) {
                _context.n = 2;
                break;
              }
              this.listLoading = true;
              _context.n = 1;
              return getMissionInfoReadings(this.missionInfo.id);
            case 1:
              data = _context.v;
              this.list = data;
              this.listLoading = false;
              this.$nextTick(function () {
                _this2.setSort();
              });
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }()
  }, {
    key: "setSort",
    value: function setSort() {
      var _this3 = this;
      var el = this.$refs.draggableTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0];
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost',
        onEnd: function onEnd(evt) {
          if (typeof evt.oldIndex !== 'undefined' && typeof evt.newIndex !== 'undefined') {
            var targetRow = _this3.list.splice(evt.oldIndex, 1)[0];
            _this3.list.splice(evt.newIndex, 0, targetRow);
          }
        }
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.$emit('update:visible', false);
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      this.getList();
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      var reading = JSON.parse(JSON.stringify(defaultMissionInfReadingData));
      reading.missionInfoId = this.missionInfo.id;
      if (this.list.length === 0) {
        reading.order = 1;
      } else {
        var maxOrder = Math.max.apply(Math, this.list.map(function (o) {
          return o.order;
        }));
        reading.order = maxOrder + 1;
      }
      this.edit = {
        showDialog: true,
        title: 'Create Reading',
        action: 'create',
        reading: reading
      };
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(mi) {
      this.edit = {
        showDialog: true,
        title: 'Edit Reading',
        action: 'edit',
        reading: JSON.parse(JSON.stringify(mi))
      };
    }
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(mi) {
        var _this4 = this;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.$confirm('Are you sure to delete this item?', 'Warning', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
              }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                var data;
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      _this4.listLoading = true;
                      _context2.n = 1;
                      return deleteMissionInfoReading(mi.missionInfoId, mi.id);
                    case 1:
                      data = _context2.v;
                      _this4.list = data;
                      _this4.$message({
                        type: 'success',
                        message: 'Deleted!'
                      });
                      _this4.listLoading = false;
                      _this4.getList();
                    case 2:
                      return _context2.a(2);
                  }
                }, _callee2);
              }))).catch(function (err) {
                console.error(err);
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleDelete(_x) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "handleUpdateOrder",
    value: function () {
      var _handleUpdateOrder = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var order, orders, data;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this.listLoading = true;
              order = 1;
              orders = this.list.map(function (mi) {
                return {
                  id: mi.id,
                  order: order++
                };
              });
              _context4.n = 1;
              return updateMissionInfoReadingOrder(this.missionInfo.id, orders);
            case 1:
              data = _context4.v;
              this.getList();
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleUpdateOrder() {
        return _handleUpdateOrder.apply(this, arguments);
      }
      return handleUpdateOrder;
    }()
  }]);
}(Vue);
__decorate([Prop({
  required: false
})], default_1.prototype, "missionInfo", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "title", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "visible", void 0);
__decorate([Prop({
  required: false
})], default_1.prototype, "action", void 0);
__decorate([Watch('edit.showDialog', {
  deep: true
})], default_1.prototype, "onShowDialogChange", null);
default_1 = __decorate([Component({
  name: 'DetailReading',
  components: {
    WriteReading: WriteReading
  }
})], default_1);
export default default_1;